module.exports = __webpack_public_path__ + "img/Debbie_King@1x.fed70dd9.png";